import {Injectable, Injector} from '@angular/core';
import {ApiResponse, BaseApiService} from '../base-api.service';
import {DepartmentsModelService} from '../../Models/Core/departments-model.service';

@Injectable({
  providedIn: 'root'
})
export class DepartmentsApiService extends BaseApiService {

  constructor(
    protected override injector: Injector,
    public model: DepartmentsModelService,
  ) {
    super(injector);
  }


  /**
   * Obtener los departamentos
   *
   */
  public getDepartments(save: boolean = true): Promise<ApiResponse> {

    return new Promise((resolve, reject) => {

      return this.httpCall('getDepartamentos', {}, 'get').subscribe({
        next: (response) => {
          if (save) {
            this.model.save(response.data);
          }

          resolve(response);
        },
        error: (err) => {
          reject(err)
        }
      });

    });

  }

}
